import React from "react";
import { Checkbox } from "@veneer/core";
import { numberFormatCommaTwoFraction } from "./../../../common/js/utils/numberFormat";
function SpecialConditionDetailTypes3_14({ specialCondition }) {

    const epmCheckbox = () => {
        //14 represents Fixed Bonus + EPM
        if (specialCondition.idSpecialConditionType == 14) {
          return  <Checkbox
             defaultChecked
             id="checkbox-checked"
             label="Includes EPM"
             disabled
            />
        } 
    }
    
    return (<>
    {(specialCondition.idSpecialConditionType==25)?(<>
        <div>Percentage: {numberFormatCommaTwoFraction(specialCondition.percentage * 100)} %</div>
        <div>Maximum width: {specialCondition.minimumImp}</div>
        <div>{epmCheckbox()}</div>
    </>):(<>
        <div>Percentage: {numberFormatCommaTwoFraction(specialCondition.percentage * 100)} %</div>
        <div>Minimum impresions: {specialCondition.minimumImp}</div>
        <div>{epmCheckbox()}</div>
    </>)}
        
    </>);
}
export default SpecialConditionDetailTypes3_14;